
import React, { PureComponent, Fragment } from "react";
import Truncate from "react-truncate";
import Calculator from "../Calculator/Calculator";
import { t, x } from "../../../helpers/localization";
import { Interpolate } from "react-i18next";

import { DialogHeader, DialogBody, Button, Link, DivTooltip, TooltipBody, Currency } from "@wg/wows-react-uikit";

import { Balance } from "../../../Reducers/ReducerTreasury";

import { IProps as ICurrency, CurrencyType } from "../../UIKit/Currency/Currency";

import styles from "./DistributionDialog.scss";

export type IProps = {
  distributionList: Array<number>;
  distributionSum: number;
  members: Array<any>; // TODO add Member description
  totalBalanceList: Balance;
  selectedDistributionCurrency: CurrencyType;
  treasuryMinDistributionSumm: number;

  selectDistributionCurrency: (type: CurrencyType) => void;
  hideDistributionDialog: () => void;
  setDistributionSum: (sum: number) => void;
  distributeResources: () => void;
};

class DistributionDialog extends PureComponent<IProps, any> {


  state = {
    truncate: true,
    restCount: 99
  };

  truncRef = {};

  moreText = t('... еще ');

  toggleShowUsers = () => {
    this.setState({
      truncate: !this.state.truncate
    });
  };

  handleTruncate = (e: any) => {
    if (this.truncRef !== null && this.truncRef.elements) {
      let cutText = this.truncRef.elements.target.outerText;
      const fullText = this.truncRef.elements.text.outerText;

      if (cutText && fullText) {
        const rest = fullText.substring(cutText.length - this.moreText.length, fullText.length);
        const restCount = rest.split(', ').length;
        this.setState({
          restCount
        });

      }
    }
  };

  getUserNames = () => {
    if (this.props.distributionList.length === 1) {
      const name = this.props.members.filter(m => {
        return this.props.distributionList.indexOf(m.id) !== -1;
      }).map(m => m.name).join('');

      return <Interpolate i18nKey={x('Начислить ресурсы игроку: %(name)s')} name={name} parent={'p'} />;
    } else {
      const names = this.props.members.filter(m => {
        return this.props.distributionList.indexOf(m.id) !== -1;
      }).map(m => m.name).join(', ');

      return <Interpolate i18nKey={x('%(title)s %(names)s %(more)s')} title={<span className={styles.betweenTitle}>{t('Распределить ресурсы между игроками:')}</span>} names={names} more={this.state.truncate ? null : <Fragment>
                            &nbsp;
                            <Link isActionLink={false} arrow={''} onClick={this.toggleShowUsers}>
                                {t('скрыть')}
                            </Link>
                        </Fragment>} parent={'p'} />;
    }
  };

  render() {

    const isDistributeButtonDisabled = this.props.distributionSum < this.props.treasuryMinDistributionSumm;

    return <Fragment>
                <DialogHeader>{t('Распределение ресурсов')}</DialogHeader>
                <DialogBody className={styles.dialogBodyWrapper}>
                    <div className={`${styles.dialogRow} ${styles.userNamesList}`}>
                        <Truncate ref={ref => {
            if (ref) {
              this.truncRef = ref;
            }
          }} trimWhitespace={false} lines={this.state.truncate ? 2 : false} ellipsis={<Fragment>
                                    &nbsp;
                                    <Link isActionLink={false} arrow={''} onClick={this.toggleShowUsers}>
                                        {t('показать всех')}
                                    </Link>
                                </Fragment>} onTruncate={this.handleTruncate}>
                            {this.getUserNames()}
                        </Truncate>
                    </div>
                    <Calculator userCount={this.props.distributionList.length} distributionSum={this.props.distributionSum} setDistributionSum={this.props.setDistributionSum} totalBalanceList={this.props.totalBalanceList} selectedDistributionCurrency={this.props.selectedDistributionCurrency} selectDistributionCurrency={this.props.selectDistributionCurrency} treasuryMinDistributionSumm={this.props.treasuryMinDistributionSumm} />
                    <div className={styles.dialogActionRow}>
                        <DivTooltip tooltipBody={isDistributeButtonDisabled ? <TooltipBody>
                                    <Interpolate i18nKey={x('Минимальная сумма для распределения на одного игрока %(currency)s')} currency={<Currency isBold amount={this.props.treasuryMinDistributionSumm} type={Currency.types[this.props.selectedDistributionCurrency]} t={t} />} t={t} />
                                </TooltipBody> : null}>
                            <Button onClick={this.props.distributeResources} isDisabled={isDistributeButtonDisabled}>
                                {t('Распределить')}
                            </Button>
                        </DivTooltip>
                        <Button onClick={this.props.hideDistributionDialog}>
                            {t('Закрыть')}
                        </Button>
                    </div>
                </DialogBody>
            </Fragment>;
  }
}

export default DistributionDialog;